module.exports = __webpack_public_path__ + "static/media/simin.dcc3d8a1.jpg";